import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

/**
 * 🧩 Interface Campanha
 * Alinhar com o modelo do backend (exemplo típico)
 */
export interface Campanha {
  id: number;
  nome: string;
  dataInicio?: string | null;
  dataFim?: string | null;
  createdAt?: string;
  updatedAt?: string;
  active?: number;
  modeloCampanhaId: number;
}

/**
 * 🔹 Listar campanhas de um modelo específico
 */
export const listarCampanhasPorModeloService = async (
  modeloId: number
): Promise<Campanha[] | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/campanhas/modelo/${modeloId}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao listar campanhas por modelo:", error);
    }
  }
};

/**
 * 🔹 Buscar campanha por ID
 */
export const buscarCampanhaPorIdService = async (
  id: number
): Promise<Campanha | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/campanhas/${id}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao buscar campanha:", error);
    }
  }
};

/**
 * 🔹 Criar nova campanha
 */
export const criarCampanhaService = async (
  campanhaData: Partial<Campanha>
): Promise<Campanha | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/campanhas`;
    try {
      const response = await axios.post(URL, campanhaData, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao criar campanha:", error);
    }
  }
};

/**
 * 🔹 Atualizar campanha existente
 */
export const atualizarCampanhaService = async (
  id: number,
  campanhaData: Partial<Campanha>
): Promise<Campanha | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/campanhas/${id}`;
    try {
      const response = await axios.put(URL, campanhaData, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao atualizar campanha:", error);
    }
  }
};

/**
 * 🔹 Excluir campanha
 */
export const excluirCampanhaService = async (id: number): Promise<void> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/campanhas/${id}`;
    try {
      await axios.delete(URL, {
        headers: { Authorization: Token.AuthStr },
      });
    } catch (error) {
      console.error("Erro ao excluir campanha:", error);
    }
  }
};

/**
 * 🔹 Exporta o objeto unificado
 */
export const campanhaService = {
  listarCampanhasPorModeloService,
  buscarCampanhaPorIdService,
  criarCampanhaService,
  atualizarCampanhaService,
  excluirCampanhaService,
};
